import { useState } from "react";
import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { IoClose } from "react-icons/io5";

const Dialog = ({ open, onOpenChange, children }: any) => {
	return (
		<DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
			{children}
		</DialogPrimitive.Root>
	);
};

const DialogTrigger = DialogPrimitive.Trigger;

const DialogContent = React.forwardRef(({ className, ...props }: any, ref) => (
	<DialogPrimitive.Portal>
		<DialogPrimitive.Overlay className="fixed inset-0 bg-black bg-opacity-30 z-50 pt-10" />
		<DialogPrimitive.Content
			ref={ref}
			className=
			"fixed mt-6 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg max-w-lg w-full z-50"
			{...props}
		>
			{props.children}
			<DialogPrimitive.Close className="absolute top-3 right-3 text-gray-500 hover:text-gray-700">
				<IoClose className="w-5 h-5" />
			</DialogPrimitive.Close>
		</DialogPrimitive.Content>
	</DialogPrimitive.Portal>
));

const DialogHeader = ({ children }: any) => <div className="mb-4">{children}</div>;
const DialogTitle = ({ children }: any) => <h2 className="text-lg font-semibold">{children}</h2>;

export { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle };

const Button = ({ className, children, ...props }: any) => {
	return (
		<button
			className=
			"px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
			{...props}
		>
			{children}
		</button>
	);
};

export { Button };

const InfoPopup = ({ data, open, setOpen }: any) => {
	const dummyImage = require('../../assets/img/image.png')
	const datama = {
		symbol: 'url-to-large-image.jpg',
		name: 'Example Name',
		LogisticsVehicleCategoryName: 'Mini Truck',
		Description: 'Suitable for small loads',
		otherImages: [
			dummyImage,
			dummyImage,

		]
	};

	const bodyType = (id: number) => {
		switch (id) {
			case 10:
				return 'Open Type';
			case 20:
				return 'Close Type';

			case 30:
				return 'Refrigerator Type'
		}
	}
	return (
		<>
			{data ?
				<Dialog open={open} onOpenChange={setOpen}>
					<DialogContent className="max-w-3xl w-full p-4 ">

						<div className="space-y-1  ">

							<div className="grid grid-cols-2 gap-2  ">
								{/* First Image - Large (spans 2 rows) */}
								<div className="row-span-2">

									{data?.MediaMappings?.MediaFiles?.length > 0 ? (
										<img
											src={data?.MediaMappings?.MediaFiles[0]?.FileMappingURL}
											alt={""}
											className="w-full h-32 object-cover rounded-xl"
										/>
									) : (
										<img
											src={dummyImage}
											alt={datama?.name}
											className="w-full h-32 object-cover rounded-xl"
										/>
									)}
								</div>

								{/* Other Images - Small */}

								<div>
									{data.MediaMappings?.MediaFiles[1]?.FileMappingURL ? (
										<img
											src={data?.MediaMappings?.MediaFiles[1]?.FileMappingURL}
											alt={""}
											className="w-16 h-14 object-cover rounded-md "
										/>
									) : (
										<img
											src={dummyImage}
											alt={``}
											className="w-16 h-14 object-cover rounded-md"
										/>
									)}

								</div>
								<div >
									{data?.MediaMappings?.MediaFiles[2]?.FileMappingURL ? (
										<img
											src={data?.MediaMappings?.MediaFiles[2]?.FileMappingURL}
											alt={""}
											className="w-16 h-14 object-cover rounded-md"
										/>
									) : (
										<img
											src={dummyImage}
											alt={``}
											className="w-16 h-14 object-cover rounded-md"
										/>
									)}
								</div>

							</div>

							<div className="text-base text-gray-500 ">
								<strong>Vehicle Type:</strong> {data?.VehicleName}
							</div>
							<div className="text-xs text-gray-500">
								{data?.VehicleDescription}
							</div>
						</div>
						<div className="text-sm text-gray-500 border-t pt-3 mt-3">
							<strong>Vehicle Category Information:</strong>
							<div className="grid grid-cols-2 pl-5">
								<div>Trip Base Price:</div> <div>₹ {data?.TripVehicleBasePrice}</div>
								<div>Body Type:</div> <div>{bodyType(data?.VehicleBodyTypeId)}</div>
								<div>Loading Capacity:</div> <div>{data?.LoadingCapacity} kg</div>
								<div>Vehicle Dimension(LxWxH):</div> <div>{data?.VehicleDimension?.length?.value || 0}x{data?.VehicleDimension?.breadth?.value || 0}x{data?.VehicleDimension?.height?.value || 0}  meter</div>
							</div>
						</div>
					</DialogContent>
				</Dialog>
				: null}
		</>
	);
};

export default InfoPopup;
